import React from 'react';
import { Helmet } from 'react-helmet';
export const MetaHead = () => {
  return <Helmet data-id="element-220">
      <meta name="facebook-domain-verification" content="8g7igpzg6208dsgp55uaob5msq5lus" data-id="element-221" />
    </Helmet>;
};